import { z } from 'zod'

export interface NextProfitsParams {
  accountId: string
  bucketId?: string
}

export const profitsSchema = z.object({
  interest: z.number(),
  iof: z.number(),
  ir: z.number(),
  returnAmount: z.number()
})

export type Profits = z.infer<typeof profitsSchema>

export const nextProfitsTotalResponseSchema = z.object({
  profits: profitsSchema
})

export type NextProfitsTotalResponse = z.infer<typeof nextProfitsTotalResponseSchema>

export const nextProfitSchema = z.object({
  bucketId: z.string(),
  bucketName: z.string(),
  date: z.string(),
  profits: profitsSchema
})

export type NextProfit = z.infer<typeof nextProfitSchema>

export const nextProfitsResponseSchema = z.object({
  nextProfits: z.array(nextProfitSchema)
})

export type NextProfitsResponse = z.infer<typeof nextProfitsResponseSchema>
